// extracted by mini-css-extract-plugin
module.exports = {"dispute":"DisputePopup_dispute__Zfjix","text":"DisputePopup_text__te6PH","footer":"DisputePopup_footer___m_qh","disabled":"DisputePopup_disabled__R7Cce"};